<template>
	<div class="header">
        <div class="package">
			<div class="bj">
                <img src="img/banner_bj.jpg"/>
			</div>
			<div class="centre">
                <img src="img/banner_qj.png"/>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:"Header",
		data() {
			return {
				
			};
		},
		methods:{
			addFavoritesClick(){
			}
		}
	}
</script>

<style lang="scss" scoped>

.header{
    width: 100%;
    height: 150px;
    background-color: #045978;
    display: flex;
    justify-content: center;
    
    .package{
        width: 100%;
        height: 150px;
        position:relative;


        display: flex;
        justify-content: center;
        .centre{
            // border: 1px red solid;
            position: absolute;
            height: 100%;
            width: 1300px;
            display: flex;
            justify-content: space-between;
            
            // text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            
            image{
                width: 100%;
                height: 100%;
            }
        }
        .bj{
            color: salmon;
            position: absolute;
            // width: 100%;
            // background-color: salmon;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: flex-end;
            image{
                height: 100%;
            }
        }
    }
    
}
</style>